import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

export const EMPLOYMENT_TYPES = [["casual", "Casual"], ["part_time", "Part-time"], ["full_time", "Full-time"], ["fixed_weekly", "Fixed weekly wage"], ["fixed_fortnightly", "Fixed fortnightly wage"], ["salaried", "Salaried"]];
export const empLabel = (v) => EMPLOYMENT_TYPES.find((e) => e[0] === v)?.[1] || v || "—";

export const useStaffGroups = () => {
  const [groups, setGroups] = useState([]);
  const load = useCallback(() => api.get("/staff-groups").then((r) => setGroups(r.data)).catch(() => {}), []);
  useEffect(() => {
    load();
  }, [load]);
  const byId = Object.fromEntries(groups.map((g) => [g.group_id, g]));
  return { groups, byId, load, departments: groups.filter((g) => g.kind === "department"), roles: groups.filter((g) => g.kind === "job_role") };
};

export const GroupBadge = ({ group, testid }) => (group ? (
  <span className="inline-flex max-w-full items-center gap-1.5 rounded-full border px-2 py-0.5 text-xs font-semibold" style={{ borderColor: `${group.color}66`, backgroundColor: `${group.color}14`, color: "#0B2D5B" }} data-testid={testid}>
    <span className="h-2 w-2 shrink-0 rounded-full" style={{ backgroundColor: group.color }} /><span className="truncate">{group.name}</span>
  </span>
) : null);
